import clsx from 'clsx'
import { FC } from 'react'

import arrowIcon from '@/shared/assets/icons/arrow.svg'
import { Info } from '@/shared/lib/@deprecated/iport-icons'
import { Icon } from '@/shared/ui/icon'

import cls from './CardNotification.module.scss'

type NotificationCardProps = {
	description?: string
	withArrowPrefix?: boolean
	disabled?: boolean
	onClick?: () => void
}

export const NotificationCard: FC<NotificationCardProps> = ({ description, withArrowPrefix, disabled, onClick }) => (
	<article
		className={clsx(
			cls.cardNotification,
			disabled && cls.cardNotification_disabled,
			!!onClick && cls.cardNotification_withPointer
		)}
		onClick={() => onClick?.()}>
		<Info className={cls.cardNotification__tip} fill="none" size={24} />
		<span>{description}</span>
		{withArrowPrefix && (
			<div className={cls.cardNotification__arrowPrefix}>
				<Icon icon={arrowIcon} width={18} height={18} />
			</div>
		)}
	</article>
)
